import React from 'react';

import {hooks} from '../hooks';
import {ActivitiesType, ExtraCurricularType} from '../types';
import {components} from '../components';
import {Routes} from '../routes';
  
type Props = {
  index: number;
  extracurricular: ExtraCurricularType;
  isLast: boolean;
};

export const ExtraCurricularItem: React.FC<Props> = ({index, extracurricular, isLast}) => {
  const navigate = hooks.useNavigate();

  return (
    <>
    <div
      style={{
        padding: 14,
        paddingTop: 14,
        paddingBottom: 14,
        borderRadius: 10,
        position: 'relative',
        marginBottom: 15,
        backgroundColor: 'var(--white-color)',
        display: 'block',
        height: 'auto',
        maxHeight: "100%",
      }}
      onClick={() => navigate(`/detail-extra-curricular/${extracurricular.id}`, {state: {extracurricular}})}
    >
      <div>
        <img
          src={extracurricular.banner}
          alt={extracurricular.title}
          style={{width: '100%', borderRadius: 6, objectFit: 'cover', height: 220}}
        />
        <div className='row-center-space-between' style={{paddingTop: 10}}>
          <h4 className='number-of-lines-2' style={{padding: '6px 0 0 0'}}>{extracurricular.title}</h4>
        </div>
      </div>
      {/* <components.Name
        son={son.name}
        containerStyle={{marginBottom: 3}}
      /> */}
      <div style={{width: '100%'}}>
        <p className='t12 number-of-lines-3' style={{marginBottom: 10, overflow: 'hidden', paddingTop: 10}}>{extracurricular.description}</p>
      </div>
    </div>
    </>
  );
};
